import { PageHeader } from "antd"
import React from "react"
import { useHistory, useLocation } from "react-router-dom"

interface PageCustomHeaderProps {
    title: React.ReactNode
    subTitle?: string
    className?: string
    actionButtons?: React.ReactNode
}

export interface ExpenseSwitchingLocationState {
    expenseSwitchingSteps?: number
}

export const PageCustomHeader = ({ className, title, subTitle, actionButtons }: PageCustomHeaderProps) => {
    const history = useHistory()
    const location = useLocation<ExpenseSwitchingLocationState>()

    const goBack = () => {
        if (location.state?.expenseSwitchingSteps) {
            history.go(0 - (location.state.expenseSwitchingSteps + 1))
        } else {
            history.goBack()
        }
    }

    return <PageHeader className={className} onBack={() => goBack()} title={title} subTitle={subTitle} extra={actionButtons} />
}
